// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fw2RWWaNhewbWq3w {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 4px 0;
}

.PAUrfNzEycM9rxZV {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.FBVSV8EWEVMwm_AZ .p-fileupload-choose {
  border-radius: 12px;
  overflow: hidden;
}
.FBVSV8EWEVMwm_AZ .p-fileupload-choose .p-button {
  border-radius: 12px;
}



.HM1gbAmZTQcyfS5_ {
  margin-top: 7px;
}

.OSrEpWtIO80SSgDc {
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
}
.sGsZX3R_AUAYbkUT .p-button {
  width: fit-content !important;
}

.WWfcQYKSxBEMVcQJ {
  width: 100%;
}

.VVeTUB0lcRsNwmn1 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.tr8jqg9J88YKQcqo {
  display: flex;
  align-items: center;
}

.AQl6PN9TVnIbevsy {
  width: 140px;
  height: 100px;
  background-size: cover;
  background-position: center;
  margin-top: 4px;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/SubStationsInputs.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB;;;iCAG+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".divider {\r\n  border: none;\r\n  border-top: 1px solid #e0e0e0;\r\n  margin: 4px 0;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.substationFile :global(.p-fileupload-choose) {\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n.substationFile :global(.p-fileupload-choose .p-button) {\r\n  border-radius: 12px;\r\n}\r\n\r\n\r\n\r\n.removeSubstationBtn {\r\n  margin-top: 7px;\r\n}\r\n\r\n.addSubstationWrapper {\r\n  width: fit-content;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-self: flex-end;\r\n}\r\n.addSubstationBtn :global(.p-button) {\r\n  width: fit-content !important;\r\n}\r\n\r\n.fullWidth {\r\n  width: 100%;\r\n}\r\n\r\n.controlsColumn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.switchWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.preview {\r\n  width: 140px;\r\n  height: 100px;\r\n  background-size: cover;\r\n  background-position: center;\r\n  margin-top: 4px;\r\n  border-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var divider = `fw2RWWaNhewbWq3w`;
export var input = `PAUrfNzEycM9rxZV`;
export var substationFile = `FBVSV8EWEVMwm_AZ`;
export var removeSubstationBtn = `HM1gbAmZTQcyfS5_`;
export var addSubstationWrapper = `OSrEpWtIO80SSgDc`;
export var addSubstationBtn = `sGsZX3R_AUAYbkUT`;
export var fullWidth = `WWfcQYKSxBEMVcQJ`;
export var controlsColumn = `VVeTUB0lcRsNwmn1`;
export var switchWrapper = `tr8jqg9J88YKQcqo`;
export var preview = `AQl6PN9TVnIbevsy`;
export default ___CSS_LOADER_EXPORT___;
